import Skeleton from '@carvana/ds-skeleton';
import { HERO_HEIGHT } from './OrderStatusModule.masks';

export default function OrderStatusModuleSkeleton() {
  return (
    <div className="flex w-full flex-col bg-background-default">
      <div className="sm:hidden">
        <div className="h-[210px] w-full bg-background-secondary" />
        <div className="mx-auto w-full max-w-[1352px] p-2xl">
          <div className="flex flex-col gap-lg">
            <Skeleton height={28} width="55%" />
            <Skeleton height={18} width="80%" />
            <Skeleton height={18} width="65%" />
            <Skeleton className="mt-lg rounded-full" height={44} width="100%" />
          </div>
        </div>
      </div>

      <div
        className="relative hidden w-full bg-background-secondary sm:block"
        style={{ height: HERO_HEIGHT }}
      >
        <div className="relative mx-auto flex h-full w-full max-w-[1352px] items-center pl-4xl">
          <div className="flex w-full max-w-[420px] flex-col gap-lg md:max-w-[480px]">
            <Skeleton height={32} width="60%" />
            <Skeleton height={20} width="85%" />
            <Skeleton height={20} width="70%" />
            <Skeleton className="mt-lg rounded-full" height={48} width="55%" />
          </div>
        </div>
      </div>
    </div>
  );
}
